<div class="table-container" *ngIf="dataTable">
    <p-table [autoLayout]="true" [selection]="internalSelection" (selectionChange)="handleSelectionChange($event)"
        (onRowSelect)="onRowSelect($event)" [scrollable]="true" [selectionMode]="checkboxColumn ? 'multiple' : null"
        [dataKey]="dataKey" [resizableColumns]="true" [value]="dataTable" [tableStyle]="{ 'min-width': '50rem' }"
        scrollHeight="{{scrollHeight}}" styleClass="p-datatable-striped" responsiveLayout="stack"
        [paginator]="(dataSource.length > 4)" [rowsPerPageOptions]="[5,10,50,100]" [rows]="10"
        (onPage)="paginate($event)" [first]="first">
        <!-- Header -->
        <ng-template pTemplate="header">
            <tr>
                <!-- Sticky No column -->
                <th class="sticky-column-index">
                    No
                </th>
                <th *ngIf="checkboxColumn" class="checkbox-column" (click)="$event.stopPropagation()">
                    <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                </th>
                <!-- Sticky first column -->
                <th *ngIf="fixedColumnHeader" class="sticky-column" [ngClass]="{'stretch': visibleColumns.length === 1, 'with-checkbox': checkboxColumn}">
                    <div style="display: flex; align-items: center; justify-content: space-between;">
                        <span>{{ fixedColumnHeader.label }}</span>
                        <div style="display: flex; align-items: center; gap: 4px;">
                            <p-sortIcon *ngIf="fixedColumnHeader.sort" field="{{ fixedColumnHeader.value }}"></p-sortIcon>
                            <p-columnFilter *ngIf="fixedColumnHeader.filter" field="{{ fixedColumnHeader.value }}" display="menu" [matchMode]="'contains'"
                                [matchModeOptions]="[
                                    { label: 'Starts With', value: 'startsWith' },
                                    { label: 'Contains', value: 'contains' },
                                    { label: 'Ends With', value: 'endsWith' }
                                ]"></p-columnFilter>
                        </div>
                    </div>
                </th>
                <!-- Dynamic columns -->
                <th *ngFor="let col of visibleColumns" [pSortableColumn]="col.value">
                    <div style="display: flex; align-items: center; justify-content: space-between;">
                        <span>{{ col.label }}</span>
                        <div style="display: flex; align-items: center; gap: 4px;">
                            <!-- Sort Icon -->
                            <p-sortIcon *ngIf="col.sort" field="{{ col.value }}"></p-sortIcon>
                            <!-- Filter Icon -->
                            <p-columnFilter *ngIf="col.filter" field="{{ col.value }}" display="menu" [matchMode]="'contains'"
                                [matchModeOptions]="[
                                    { label: 'Starts With', value: 'startsWith' },
                                    { label: 'Contains', value: 'contains' },
                                    { label: 'Ends With', value: 'endsWith' }
                                ]"></p-columnFilter>
                        </div>
                    </div>
                </th>
            </tr>
        </ng-template>

        <!-- Body -->
        <ng-template pTemplate="body" let-rowData>
            <tr (click)="rowClicked(rowData)">
                <!-- Sticky No column -->
                <td class="sticky-column-index">
                    {{ rowData['index'] }}
                </td>
                <!-- Checkbox column -->
                <td *ngIf="checkboxColumn" class="checkbox-column" (click)="$event.stopPropagation()">
                    <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                </td>
                <!-- Sticky first column -->
                <td *ngIf="fixedColumnHeader" class="sticky-column" [ngClass]="{'stretch': visibleColumns.length === 1, 'with-checkbox': checkboxColumn}">
                    {{ rowData[fixedColumnHeader.value] }}
                </td>
                <!-- Dynamic columns -->
                <td *ngFor="let col of visibleColumns">
                    <div class="fixed-checkbox-col" class="dotStyle" *ngIf="col.customTemplate && col.template" (click)="$event.stopPropagation()">
                        <ng-container *ngTemplateOutlet="col.template; context: { context: rowData }"></ng-container>
                    </div>
                    <div *ngIf="!col.customTemplate">
                        {{ rowData[col.value] }}
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div class="empty-table" *ngIf="!dataSource || dataSource.length === 0">
        <span>No data available</span>
    </div>
</div>
